export var JoinRelationship;
(function (JoinRelationship) {
    JoinRelationship["ONE_TO_MANY"] = "one-to-many";
    JoinRelationship["MANY_TO_ONE"] = "many-to-one";
    JoinRelationship["ONE_TO_ONE"] = "one-to-one";
    JoinRelationship["MANY_TO_MANY"] = "many-to-many";
})(JoinRelationship || (JoinRelationship = {}));
export var ExploreType;
(function (ExploreType) {
    ExploreType["VIRTUAL"] = "virtual";
    ExploreType["DEFAULT"] = "default";
    ExploreType["PRE_AGGREGATE"] = "pre_aggregate";
    ExploreType["EXTERNAL_SOURCE"] = "external_source";
})(ExploreType || (ExploreType = {}));
/**
 * Explores created and owned by users in the app rather than compiled from
 * dbt. They live only in the explore cache and must survive dbt recompiles.
 */
export const USER_MANAGED_EXPLORE_TYPES = [
    ExploreType.VIRTUAL,
    ExploreType.EXTERNAL_SOURCE,
];
export const isUserManagedExplore = (explore) => explore.type !== undefined &&
    USER_MANAGED_EXPLORE_TYPES.includes(explore.type);
export var InlineErrorType;
(function (InlineErrorType) {
    // Fatal error types (ExploreError - explore is broken)
    InlineErrorType["METADATA_PARSE_ERROR"] = "METADATA_PARSE_ERROR";
    InlineErrorType["NO_DIMENSIONS_FOUND"] = "NO_DIMENSIONS_FOUND";
    // Warning types (Explore.warnings - explore still usable)
    InlineErrorType["SKIPPED_JOIN"] = "SKIPPED_JOIN";
    InlineErrorType["MISSING_TABLE"] = "MISSING_TABLE";
    InlineErrorType["FIELD_ERROR"] = "FIELD_ERROR";
    InlineErrorType["SET_VALIDATION_ERROR"] = "SET_VALIDATION_ERROR";
    InlineErrorType["SHOW_UNDERLYING_VALUES_ERROR"] = "SHOW_UNDERLYING_VALUES_ERROR";
    InlineErrorType["INVALID_PARAMETER"] = "INVALID_PARAMETER";
    InlineErrorType["DUPLICATE_FIELD_NAME"] = "DUPLICATE_FIELD_NAME";
    InlineErrorType["MODEL_FILTER_ERROR"] = "MODEL_FILTER_ERROR";
    InlineErrorType["WAREHOUSE_COLUMN_ERROR"] = "WAREHOUSE_COLUMN_ERROR";
})(InlineErrorType || (InlineErrorType = {}));
/**
 * Check if an explore is an ExploreError (failed to compile completely).
 * ExploreError has 'errors' field, working Explore does not.
 */
export const isExploreError = (explore) => 'errors' in explore;
export const getExploreSplitCandidates = (exploreName, explores) => {
    const candidates = explores.flatMap((explore) => {
        if ('errors' in explore)
            return [];
        const baseTable = explore.tables[explore.baseTable];
        // Package names can contain `__`, so match the qualified suffix rather
        // than treating the separator as something we can parse.
        return baseTable?.originalName === exploreName &&
            explore.name.endsWith(`__${exploreName}`)
            ? [explore.name]
            : [];
    });
    return [...new Set(candidates)].sort();
};
/**
 * Check if a SummaryExplore is from an ExploreError (completely failed to compile).
 * ExploreError has 'errors' field with actual errors, working Explore may have 'warnings'.
 */
export const isSummaryExploreError = (summary) => 'errors' in summary &&
    summary.errors !== null &&
    summary.errors !== undefined;
export var CustomViewType;
(function (CustomViewType) {
    CustomViewType["VIRTUAL"] = "virtual";
    CustomViewType["WRITE_BACK"] = "write_back";
})(CustomViewType || (CustomViewType = {}));
//# sourceMappingURL=explore.js.map